import React from 'react';

import ImagePrime from '../Image';

// This is just a wrapper that helps deal with some Gatsby idiosyncrasies and makes writing MDX posts a little easier and less error prone.
const Image = ({imgs, name, ...props}) => {

  if (imgs && imgs[name]) {
    const entry = imgs[name];
    // Prefer new gatsbyImageData if present (direct or under childImageSharp)
    const gatsbyImageData =
      (entry && entry.childImageSharp && entry.childImageSharp.gatsbyImageData)
      || (entry && (entry.images || entry.layout) && entry);

    if (gatsbyImageData) {
      return <ImagePrime image={gatsbyImageData} {...props} />;
    }
    if (entry && entry.publicURL) {
      return <img src={entry.publicURL} {...props} />;
    }
  }
  return null;
}

export default Image;
